import { call, put, takeEvery } from 'redux-saga/effects';
import {
  CASE_UPDATE_REFERENCES_BEGIN,
  CASE_UPDATE_REFERENCES_SUCCESS,
  CASE_UPDATE_REFERENCES_FAILURE,
  CASE_UPDATE_REFERENCES_DISMISS_FEEDBACK,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from 'common/selectors';

export const updateReferences = createPromiseAction(
  CASE_UPDATE_REFERENCES_BEGIN,
  (fileId, options = {}) => ({ fileId, ...options }),
);

export function dismissUpdateReferencesFeedback() {
  return {
    type: CASE_UPDATE_REFERENCES_DISMISS_FEEDBACK,
  };
}

export function* doUpdateReferences(action) {
  const {
    payload: { fileId, caseId },
  } = action;

  const res = yield call(api.post, `/cases/${caseId}/files/${fileId}/exhibit-process`);

  if (res && res.error) {
    yield put({
      type: CASE_UPDATE_REFERENCES_FAILURE,
      feedback: {
        message: 'feedback.updateReferencesFailure',
        params: { fileId },
        error: res.error,
        retryAction: action,
      },
      fileId,
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  const responseData = {
    ...(res || {}),
    fileId,
  };
  yield put({
    type: CASE_UPDATE_REFERENCES_SUCCESS,
    feedback: {
      message: 'feedback.updateReferencesSuccess',
      params: { fileId },
      success: true,
      data: responseData,
    },
  });
  return yield call(resolvePromiseAction, action, res);
}

export function* watchUpdateReferences() {
  yield takeEvery(updateReferences, withCurrentCaseId(doUpdateReferences));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_UPDATE_REFERENCES_BEGIN + '.TRIGGER':
      return {
        ...state,
        updateReferencesPending: true,
        updateReferencesFeedback: null,
      };

    case CASE_UPDATE_REFERENCES_SUCCESS:
      return {
        ...state,
        updateReferencesPending: false,
        updateReferencesFeedback: action.feedback,
        updateReferencesResult: action.feedback?.data,
        updateReferencesCompletedByFileId: {
          ...state.updateReferencesCompletedByFileId,
          [action.feedback?.params?.fileId]: true,
        },
      };

    case CASE_UPDATE_REFERENCES_FAILURE:
      return {
        ...state,
        updateReferencesPending: false,
        updateReferencesFeedback: action.feedback,
        updateReferencesResult: null,
      };

    case CASE_UPDATE_REFERENCES_DISMISS_FEEDBACK:
      return {
        ...state,
        updateReferencesFeedback: null,
        updateReferencesResult: null,
      };

    default:
      return state;
  }
}
